export const MAX_PAPER_ANALYSIS_SOURCES = 60;
